// This wrapper is to stub out commonly used Template Flow documents, namely
// contracts, NOAAs, and risk-based disclosure tables.

// Because some of our components are more molecular than we'd like for the menu,
// this directive does make some amendments to the containers it wraps. Also, use
// of these stubs makes the "print" and "download" links unusable in the component
// menu. But since appearance and style are the primary concerns right now in order
// to setup visual regression testing, the trade-off is warranted.

// Note: the iframe stubbing method here uses `srcdoc` in place of `src` which is
// not supported in IE11 or Opera, but is supported by all other browsers.
// https://caniuse.com/#search=srcdoc

const amountComponentTFlowStub = $sce => {
  return {
    restrict: "E",
    transclude: true,
    template: `
      <div ng-show="isIframe" style="margin: -2em 0;" amount-transclude></div>
      <div ng-show="!isIframe" ng-bind-html="htmlContent"></div>
    `,
    scope: {
      stubType: "@",
      isIframeStr: "@isIframe",
    },
    link: (scope, element, _attributes, _controller, transclude) => {
      scope.stubs = {
        contract: require("./stubs/contract.html"),
        noaa: require("./stubs/noaa.html"),
        rbd: require("./stubs/rbd.html"),
        default: require("./stubs/default.html"),
      };
      const stub = scope.stubs[scope.stubType] || scope.stubs.default;
      scope.htmlContent = $sce.trustAsHtml(stub);

      // Boolify string
      scope.isIframe = [true, "true"].includes(scope.isIframeStr);

      if (scope.isIframe) {
        transclude(scope, clone => {
          const iframe = clone[1];
          let $iframe;

          if (iframe.tagName === "IFRAME") {
            $iframe = $(iframe);
          } else {
            $iframe = $('<iframe>');
            $iframe.attr("style", "width: 100%; height: 299px; border: 1px solid #ccc; margin: 2em 0;");
          }

          $iframe.removeAttr("ng-src");
          $iframe.attr("srcdoc", scope.stubs[scope.stubType]);

          element.find("*[amount-transclude]").append($iframe[0].outerHTML);
        });
      }
    },
  };
};

angular
  .module("avant.customer_applications.directives")
  .directive("amountComponentTFlowStub", ["$sce", amountComponentTFlowStub]);
